import styled from 'styled-components';

export const Subtitle = styled.p`
    font-size: 14px;
    margin-bottom: 20px;
`